const GlobalReducer = (state, action) => {
  switch (action.type) {
    /// Limit Search to reducer

    case "TOGGLE_ADDRESS_FORM":
      return {
        ...state,
        showAddressForm: !state.showAddressForm,
        showSearchBy: !state.showSearchBy,
      };
    case "TOGGLE_CARDTYPE_FORM":
      return {
        ...state,
        showCardTypeForm: !state.showCardTypeForm,
        showSearchBy: !state.showSearchBy,
      };

    case "UPDATE_ADDRESS":
      return {
        ...state,
        address: action.payload,
      };
    case "UPDATE_CARDTYPE":
      return {
        ...state,
        cardType: action.payload,
      };

    case "GET_STATE_FROM_LOCAL":
      return {
        ...state,
        ...action.payload,
      };

    /// Search By reducer section

    case "DISABLE_LIMIT_BTNS":
      return { ...state, disableLimitBtns: true };

    case "ENABLE_LIMIT_BTNS":
      return { ...state, disableLimitBtns: false };

    case "TOGGLE_LIMIT_BTNS":
      return { ...state, disableLimitBtns: !state.disableLimitBtns };

    case "HIDE_LIMIT_SEARCH":
      return { ...state, showLimitSearchBool: false };

    case "TOGGLE_LIMIT_SEARCH":
      return { ...state, showLimitSearchBool: !state.showLimitSearchBool };

    case "SHOW_LIMIT_SEARCH":
      return {
        ...state,
        showLimitSearchBool: true,
      };

    case "RESET_GLOBAL_STATE":
      return {
        ...action.payload,
      };

    case "RESET_SHOW_LIMIT_SEARCH":
      return {
        ...state,
        showLimitSearch: true,
      };

    //
    case "TOGGLE_SHOW_COMPANY_INPUT":
      return {
        ...state,
        showCompanyInput: !state.showCompanyInput,
      };
    case "TOGGLE_SHOW_KEYWORD_INPUT":
      return {
        ...state,
        showKeywordInput: !state.showKeywordInput,
      };
    case "TOGGLE_SHOW_CATEGORY_INPUT":
      return {
        ...state,
        showCategoryInput: !state.showCategoryInput,
      };

    case "TOGGLE_SHOW_COMPANY_SEARCH":
      return {
        ...state,
        showCompanySearch: !state.showCompanySearch,
      };
    case "TOGGLE_SHOW_KEYWORD_SEARCH":
      return {
        ...state,
        showKeywordSearch: !state.showKeywordSearch,
      };
    case "TOGGLE_SHOW_CATEGORY_SEARCH":
      return {
        ...state,
        showCategorySearch: !state.showCategorySearch,
      };

    case "RESET_SEARCHBY_BTN_STATE":
      return {
        ...state,
        showCategorySearch: true,
        showCompanySearch: true,
        showKeywordSearch: true,
        showCompanyInput: false,
        showKeywordInput: false,
        showCategoryInput: false,
        showLimitSearchBool: true,
      };

    default:
      return state;
  }
};

export default GlobalReducer;
